import { render, staticRenderFns } from "./AlreadyGiven.vue?vue&type=template&id=752c4a4c&scoped=true&"
var script = {}
import style0 from "./AlreadyGiven.vue?vue&type=style&index=0&id=752c4a4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752c4a4c",
  null
  
)

export default component.exports